import React from 'react'
import mapboxgl from 'mapbox-gl'
import AltGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

import {geojsonToArcGIS} from '@terraformer/arcgis'

//import {ApiKey} from '@esri/arcgis-rest-auth'
import {queryFeatures} from '@esri/arcgis-rest-feature-layer'
//import { arcgisRest } from '@esri/arcgis-rest-request';


import MapKey from './MapKey'
import Search from './Search'
import NeighborhoodFinder from './NeighborhoodFinder'
import DistrictFinder from './DistrictFinder'
import LotFinder from './LotFinder'
import BuildingInfo from './BuildingInfo'

//import nyNeighborhoods from '../assets/nyc-boro-zip.js'
import districtList from '../assets/districtList.js'

import '../App.css'
import '../styles/index.scss'
import '../styles/main.scss'


//this is the mapbox API key for the map image
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;


class Mapbox extends React.Component{
    constructor(props){
        super(props);
        this.state={
            // base mapbox setting
            mapStyle: 'mapbox://styles/urbandesign09/ckkg33oqr0bwa17o1s5blim1e',
            viewport: {
                latitude: 40.6979,
                longitude: -73.98,
                zoom: 9.92
            },

            // initial mapbox display setting
            overlay: {
                satellite: false,
                topography: false,
                subway: false,
                labels: false,
                landUse: true,
            },

            // initial panel display setting
            panel: {
                neighborhood: false,
                district: false,
                lot: false,
                building: false,
            },

            // initial property setting and placeholder
            input: 'New York City, New York, United States',
            neighborhoodFromGeo: '', 
            zip: '',
            districtData: '',
            lotData: '',
            wiki: []
        } 
        
        //front-end (product design)
        this.baseState = this.state; //this is the baseState
        this.handleClick = this.handleClick.bind(this);
        this.neighborWiki = this.neighborWiki.bind(this);
        this.getZoningJSON = this.getZoningJSON.bind(this);
        this.hoverFill = this.hoverFill.bind(this);
        this.getArcgisPluto = this.getArcgisPluto.bind(this);
        this.addParcelLayers = this.addParcelLayers.bind(this);
        this.getDistrictData = this.getDistrictData.bind(this);
        this.expandClick = this.expandClick.bind(this);
        this.getNeighborhoodData = this.getNeighborhoodData.bind(this);
    }

    //functions (non related to user events)
    neighborWiki(query){ //Lower East Side
        const pages = 8;
        const wikiURL = `https://en.wikipedia.org/w/api.php?action=query&list=search&srsearch=${query}&srlimit=${pages}&format=json&origin=*`
        //directly from WikiAPI documentation

        var wikiData = [];
        fetch(wikiURL) 
            .then((res) => res.json())
            .then((data) => {
                wikiData = data.query.search; //a list of wiki page objects that include title, pageid, etc.
                this.setState({
                    wiki: wikiData
                })
            })
            .catch((err)=> { //Error Handling
                console.log('Error!:'+err);
                this.setState({
                    wiki: null
                })
            })
        
            //the data structure for wikiData is an array of objects
            //each object has a page title and page id
            //need to convert each object into a button
    }

    getZoningJSON(){
        //const dList = ['C', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'M', 'M1', 'M2', 'M3', 'R', 'R1', 'R10', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9'] 
        //map each district
        //turn this into object, with color and outline colors picked out
        return districtList.map(item => {
            return (
                fetch(`https://yiwenche.github.io/nyc-zonedist-json/nyc-zoning-${item.id}.json`)
                    .then((res)=> res.json()) //make sure it is in .json format
                    .then((data)=> {
                        this.map.addSource(item.id, {
                           'type': 'geojson',
                           'data': {
                               "type": "FeatureCollection",
                               "features": data
                           } 
                        })
                        //do if/then statement here
                        //if it is a 'C, M, R' then it is a line, else a fill
                        if (item.id === 'C' || item.id === 'M' || item.id === 'R'){
                            this.map.addLayer({
                                id: item.id,
                                type: 'line',
                                source: item.id,
                                paint: {
                                    'line-width': 1.5,
                                    'line-color': item.color,
                                },
                                layout: {
                                    visibility: 'none'
                                },
                            })
                            
                        }
                        else {
                            this.map.addLayer({
                                id: item.id,
                                type: 'fill',
                                source: item.id,
                                paint: {
                                    "fill-outline-color": "#fff",
                                    "fill-color": item.color,
                                    "fill-opacity": [
                                        'case',
                                        ['boolean', ['feature-state', 'hover'], false],
                                        0.2,
                                        item.opacity,
                                    ]
                                },
                                layout: {
                                    visibility: 'none'
                                },
                            })
                        }
                    })
                    .catch((err)=> {
                        console.log(`Error ${item} data not found` + err);
                    })
            )
        })
    }

    //very glitchy hover effect
    hoverFill(){
        var hoveredStateId = null;
        return districtList.forEach(item => {
                this.map.on('mousemove', item.id, (e) => {
                    if (e.features.length > 0){
                        if (hoveredStateId){
                            this.map.setFeatureState(
                                {source: item.id, id: hoveredStateId},
                                {hover: false}
                            );
                        }      
                        hoveredStateId = e.features[0].id;
                        this.map.setFeatureState(
                            {source: item.id, id: hoveredStateId},
                            {hover: true}
                        );
                    }
                })
                
                this.map.on('mouseleave', item.id, () => {
                    if (hoveredStateId){
                        console.log('mouseout')
                        this.map.setFeatureState(
                            {source: item.id, id: hoveredStateId},
                            {hover: false}
                        );
                    }
                    hoveredStateId = null;
                })
        })
    }

    getArcgisPluto(geometry, geometryType){
        //arcgis apiKey
        //const arcgisApiKey = process.env.REACT_APP_ARCGIS_TOKEN;
        //const authentication = new ApiKey({
        //    key: arcgisApiKey
        //});
        
        queryFeatures({
            url: 'https://services5.arcgis.com/GfwWNkhOj9bNBqoJ/ArcGIS/rest/services/MAPPLUTO/FeatureServer/0',
            geometry: geometry,
            geometryType: geometryType,
            returnGeometry: true,
            spatialRel: "esriSpatialRelIntersects",
            f: "geojson",
            //add outFields for Popup Tag
        }) //I think this is where you authenticate????
        .then((response)=> {
            this.map.getSource("parcels").setData(response);
            this.setState({
                lotData: response.features[0].properties
            });
            this.getDistrictData();
        
        })
        .catch((err)=> {
            console.log(`ArcGIS not connected` + err);
        })
    }

    addParcelLayers(){ //after the features have been queried
        this.map.addSource('parcels', {
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: []
            }
        });
        this.map.addLayer({
            id: 'parcels-fill',
            source: 'parcels',
            type: 'fill',

            paint: {
                "fill-color": "orange",
                "fill-opacity": 0.5,
                "fill-outline-color": "black",
            }
        });
    }

    getDistrictData(){
        const queryDistId = this.state.lotData.ZoneDist1.split('-')[0]

        fetch('https://yiwenche.github.io/nyc-zonedist-json/districtListUpdated.json')
        .then(response => response.json())
        .then(data => data.forEach(item => {
            if (queryDistId.substring(0, 3) === item.id){
                const districtInfo = {
                    description: item.para,
                    diagram: item.diagram,
                    reading: "https://www1.nyc.gov/site/planning/zoning/districts-tools/" + item.link + '.page'
                }
                
                this.setState({
                    districtData: districtInfo
                })
            } else if (queryDistId.substring(0, 2) === item.id){
                const districtInfo = {
                    description: item.para,
                    diagram: item.diagram,
                    reading: "https://www1.nyc.gov/site/planning/zoning/districts-tools/" + item.link + '.page'
                }
                
                this.setState({
                    districtData: districtInfo
                })
            }
        })
        )
        .catch((err)=> {
            console.log(`District Information Not Connected ` + err);
        })
    }

    getNeighborhoodData(coordinates) {
        var d3 = require("d3")
        fetch('https://yiwenche.github.io/nyc-zonedist-json/neighborhoodListZoomIn.json')
        .then(response => response.json())
        .then(data => {
            for (let i=0; i<data.features.length; i++) {
                if (d3.geoContains(data.features[i], coordinates) === false){
                    //the whole data is a feature collection
                    //the item is one feature 
                    //the data is FeatureCollection 

                    this.setState(prevState => {
                        return {
                            neighborhoodFromGeo: data.features[i].properties.neighborhood,
                            boroughFromGeo: data.features[i].properties.borough
                        }
                    })
                    //searches it through Wikipedia
                    const queryText = `${this.state.neighborhoodFromGeo} ${this.state.boroughFromGeo}`
                    this.neighborWiki(queryText)
                }                        
            }
        })
        .catch((err)=> {
            console.log(`Error `+ err);
        })
    }

    //event handlers
    handleClick(e){
        //identify the id from which the event is coming from
        //refactor this to become a map
        //also map the buttons on MapKey
        var id = e.target.id;
        

        if (id==="satellite"){
            const visibility = this.map.getLayoutProperty('mapbox-satellite', 'visibility');
            if (visibility === 'visible'){
                return this.map.setLayoutProperty('mapbox-satellite', 'visibility', 'none');
            }
            else {
                return this.map.setLayoutProperty('mapbox-satellite', 'visibility', 'visible');
            }
        }
        if (id==="transit-label"){
            const visibility = this.map.getLayoutProperty('transit-label', 'visibility');
            if (visibility === 'visible'){
                return this.map.setLayoutProperty('transit-label', 'visibility', 'none');
            }
            else {
                return this.map.setLayoutProperty('transit-label', 'visibility', 'visible');
            }
        }
        if (id==="road-label-simple"){
            const visibility = this.map.getLayoutProperty('road-label-simple', 'visibility');
            const visibility2 = this.map.getLayoutProperty('waterway-label', 'visibility');
            const visibility3 = this.map.getLayoutProperty('path-pedestrian-label', 'visibility'); 
            const visibility4 = this.map.getLayoutProperty('settlement-major-label', 'visibility');
            const visibility5 = this.map.getLayoutProperty('settlement-subdivision-label', 'visibility');
            const visibility6 = this.map.getLayoutProperty('settlement-minor-label', 'visibility');
            if (visibility === 'visible' || visibility2 === 'visible' || visibility3 === 'visible' || visibility4 === 'visible' || visibility5 === 'visible' || visibility6 === 'visible'){
                return this.map.setLayoutProperty('road-label-simple', 'visibility', 'none') 
                && this.map.setLayoutProperty('waterway-label', 'visibility', 'none')
                && this.map.setLayoutProperty('path-pedestrian-label', 'visibility', 'none')
                && this.map.setLayoutProperty('settlement-major-label', 'visibility', 'none')
                && this.map.setLayoutProperty('settlement-subdivision-label', 'visibility', 'none')
                && this.map.setLayoutProperty('settlement-minor-label', 'visibility', 'none')
                ;
            }
            else {
                return this.map.setLayoutProperty('road-label-simple', 'visibility', 'visible') 
                && this.map.setLayoutProperty('waterway-label', 'visibility', 'visible')
                && this.map.setLayoutProperty('path-pedestrian-label', 'visibility', 'visible')
                && this.map.setLayoutProperty('settlement-major-label', 'visibility', 'visible')
                && this.map.setLayoutProperty('settlement-subdivision-label', 'visibility', 'visible')
                && this.map.setLayoutProperty('settlement-minor-label', 'visibility', 'visible');
            }
        }

        if (id==="landuse"){
            const visibility = this.map.getLayoutProperty('landuse', 'visibility');
            if (visibility === 'visible'){
                this.map.setLayoutProperty('landuse', 'visibility', 'none');
            }
            else {
                this.map.setLayoutProperty('landuse', 'visibility', 'visible');
            }
            //add a state marker to show if it is on
        }

        if (id==="terrain-data"){
            const visibility = this.map.getLayoutProperty('terrain-data', 'visibility');
            if (visibility === 'visible'){
                this.map.setLayoutProperty('terrain-data', 'visibility', 'none');
                return this.setState({topo: true})
            }
            else {
                this.map.setLayoutProperty('terrain-data', 'visibility', 'visible');
                return this.setState({topo: false})
            }
            //add a state marker to show if it is on
        }
        
        for (const item of districtList){
            if (id === item.id){
                const visibility = this.map.getLayoutProperty(item.id, 'visibility');
                if (visibility === 'visible'){
                    this.map.setLayoutProperty(item.id, 'visibility', 'none');
                }
                else {
                    this.map.setLayoutProperty(item.id, 'visibility', 'visible');
                }
            }
        }
        //if (id==='R10'){
        //    const visibility = this.map.getLayoutProperty('R10', 'visibility');
        //    if (visibility === 'visible'){
        //        this.map.setLayoutProperty('R10', 'visibility', 'none');
        //    }
        //    else {
        //        this.map.setLayoutProperty('R10', 'visibility', 'visible');
        //    }
        //}
        //based on id, make changes to the map
    }

    //expand panel 
    expandClick(e){
        var id = e.target.id;
        this.setState(prevState=> ({
            panel: {
                [id]: !prevState.panel[id]
            }
        }))
    }

    //lifecycle methods
    componentDidMount(){
        //the map is initialized 
        //take this variable outside of lifecycle to be accessible by multiple lifecycle methods
        //this is where to nest Mapbox GL JS components 
        this.map = new mapboxgl.Map({ 
            //creates a new instance of Map from mapboxgl
            container: this.mapContainer,
            style: this.state.mapStyle,
            center: [this.state.viewport.longitude, this.state.viewport.latitude],
            zoom: this.state.viewport.zoom,
        })

        this.geocoder = new AltGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            countries: 'us',
            placeholder: this.state.input,
            //this goes back to vanilla js
        })

        //this is vanilla Javascript that appends geocoder to geo-container and connects to map
        document.getElementById('geo-container').appendChild(this.geocoder.onAdd(this.map));

        //this is also an asynchronous
        //when the map is moved, the state is updated
        this.geocoder.on('result', (result)=> {
            const coordinates = result.result.geometry.coordinates;
            const input = result.result.place_name;  

            this.setState(prevState=>{
                return {
                    viewport: {
                        latitude: coordinates[1],
                        longitude: coordinates[0]
                    },
                    input: input,
                }
            });   

            this.getNeighborhoodData(coordinates)

            //if parcels source and layer exists, clear it each time
            //so that it is not redundant
            if (this.map.getLayer("parcels-fill")){
                this.map.removeLayer("parcels-fill")
            }
            if (this.map.getSource("parcels")){
                this.map.removeSource("parcels")
            }

            if (this.map.getLayer("neighborhood-line")){
                this.map.removeLayer("neighborhood-line")
            }
            if (this.map.getSource("nboundary")){
                this.map.removeSource("nboundary")
            }

            //this is where we put the logic for showing the plot
            const geometry = geojsonToArcGIS({
                type: "Point",
                coordinates: coordinates
            })

            const geometryType = "esriGeometryPoint";
            this.getArcgisPluto(geometry, geometryType);
            this.addParcelLayers();
            
            //this should call the Wikipedia API
            //fetch, returns a list of links 
            //we are searching for neighborhood Text      
        })

        this.map.on('load', ()=> {
            //terrain data
            this.map.addLayer({
                id: 'terrain-data',
                type: 'line',
                source: {
                    type: 'vector',
                    url: 'mapbox://mapbox.mapbox-terrain-v2'
                },
                paint: {
                    'line-width': 1,
                    'line-opacity': 0.75,
                    'line-color': "#206000",
                    'line-dasharray': [2.6, 2.6],
                },
                layout: {
                    visibility: 'none'
                },
                'source-layer': 'contour'
            });




            this.getZoningJSON();
            //this.hoverFill(); //glitchy effect, needs work
            //this.getTooltip();
     
        });

        //clicking on districts
        districtList.forEach(item => {
            return (
                this.map.on('click', item.id, (e) => {
                    const p = e.features[0].properties;
                    const shapeArea = p.Shape__Area.toFixed(0);
                    const message = `Zone District: ${p.ZONEDIST} </br>
                    Shape Area: ${shapeArea} sf`;

                    new mapboxgl.Popup()
                        .setHTML(message)
                        .setLngLat(e.lngLat)
                        .addTo(this.map)
                })
            )
        })

        //clicking on parcels-fill
        this.map.on('click', 'parcels-fill', (e) => {
            const p = e.features[0].properties;
            const message = `<p><b>${p.Address}</b></p> </br>
            Zone District: ${p.ZoneDist1} </br>
            Lot Area: ${p.LotArea} sf</br>
            Lot Front: ${p.LotFront} ft</br>
            Lot Depth: ${p.LotDepth} ft</br>
            </br>
            Year Built: ${p.YearBuilt}</br>
            Historic District: ${p.HistDist === 'null' ? 'N/A' : p.HistDist}</br>`
            ;
            
            new mapboxgl.Popup()
                .setHTML(message)
                .setLngLat(e.lngLat)
                .addTo(this.map);
        })
    }

    componentWillUnmount() {
        this.map.remove(); //teardown for map
        //question the need to teardown geocoder???
    }

    //this is the UI output
    render(){
        const {viewport} = this.state;
        const disLon = viewport.longitude.toFixed(4);
        const disLat = viewport.latitude.toFixed(4);

        const {lotData} = this.state;
        const {districtData} = this.state;


        //use state to change style props of panels
        //connect onClick of expand button to MapBox
        return (
            <div className="main" id="main">

                <Search 
                    address={this.state.input}
                    lat={disLat}
                    lon={disLon}
                />
                
                <div className="map-data">

                    <MapKey onClick={this.handleClick} />
                    <div className="mapComponent" ref={el => this.mapContainer = el} />
                        
                    <div className="panels"> 
                        <NeighborhoodFinder 
                            panel={this.state.panel}
                            zip={this.state.zip}
                            borough={this.state.boroughFromGeo}
                            neighborhood={this.state.neighborhoodFromGeo}
                            wiki={this.state.wiki}
                            expandClick={this.expandClick}
                        />
                        <DistrictFinder
                            panel={this.state.panel}
                            district={lotData.ZoneDist1} 
                            description={districtData.description}
                            diagram={districtData.diagram}
                            reading={districtData.reading}
                            historic={lotData.HistDist}
                            expandClick={this.expandClick}
                        />
                        <LotFinder 
                            address={lotData.Address}
                            lotNumber={lotData.Lot}
                            lotArea={lotData.LotArea}
                            lotFront={lotData.LotFront}
                            lotDepth={lotData.LotDepth}
                            lotType={lotData.LotType}
                            blockNumber={lotData.Block}
                            landUse={lotData.LandUse}
                            expandClick={this.expandClick}
                            panel={this.state.panel}
                        />
                        <BuildingInfo 
                            landmark={lotData.Landmark}
                            bldgClass={lotData.BldgClass}
                            bldgArea={lotData.BldgArea}
                            bldgDepth={lotData.BldgDepth}
                            bldgFront={lotData.BldgFront}
                            builtFAR={lotData.BuiltFAR}
                            yearBuilt={lotData.YearBuilt}
                            numBldg={lotData.NumBldgs}
                            numFloors={lotData.NumFloors}
                            expandClick={this.expandClick}
                            panel={this.state.panel}
                        />
                        </div>
                    </div>
                        
            </div>
        )
    }
        
}

export default Mapbox;
    //have a geolocation option 
    //start setup in Boston (see coordinates above)


    //use async/await to search information 
    //bring the entire maps module into a separate component, controlled by state

    //how to extract
